module.exports = __webpack_public_path__ + "img/logo_large.1432addb.png";